import { useQuery } from '@tanstack/react-query';
import { api, ApiResponse, tokenManager } from '../lib/api';

type FeatureFlags = Record<string, unknown>;

async function getMyFeatureFlags(): Promise<ApiResponse<FeatureFlags>> {
  const response = await api.get<ApiResponse<FeatureFlags>>('/feature-flags/me');
  return response.data;
}

/**
 * 현재 사용자의 피처 플래그 평가 결과를 가져오는 훅.
 * 5분 캐시, 1분마다 백그라운드 리프레시.
 * 인증 토큰이 없으면 API 호출을 건너뜁니다 (PDF 렌더링 등).
 */
export function useFeatureFlags() {
  const hasToken = !!tokenManager.getAccessToken();

  const { data, error, isLoading } = useQuery({
    queryKey: ['feature-flags', 'me'],
    queryFn: getMyFeatureFlags,
    staleTime: 5 * 60 * 1000,
    refetchInterval: hasToken ? 60 * 1000 : false,
    retry: 1,
    enabled: hasToken,
  });

  if (error) {
    console.warn('[useFeatureFlags] 피처 플래그 조회 실패:', error);
  }

  const flags = (data?.success ? data.data : null) ?? {};

  return {
    flags,
    isLoading,
    isEnabled: (key: string) => flags[key] === true,
  };
}
